import { signatureBurgers } from '@/mocks/menu';
import { menuCategories, extraItemImages, extraItemCutouts } from '@/mocks/pages';

export interface MenuItemView {
  id: string;
  name: string;
  price: string;
  desc: string;
  tag: string;
  image: string;
  cutout: boolean;
}

export const allMenuItems: MenuItemView[] = menuCategories.flatMap((c) => c.items).map((item) => {
  const sig = signatureBurgers.find((s) => s.id === item.id);
  const cut = extraItemCutouts.find((e) => e.id === item.id);
  const extra = extraItemImages.find((e) => e.id === item.id);
  const image = sig?.image || cut?.image || extra?.image || '';
  return { ...item, image, cutout: Boolean(sig || cut) };
});

export const findMenuItem = (id?: string) => allMenuItems.find((i) => i.id === id);